import {getPlayerFlagToken} from "../../players/getPlayerFlagToken";
import {getRandomElement} from "../../other/getRandomElement";

export const getRandomHexCoordsForStartingQuarter = (hexes, player) => {
  const playerFlagToken = getPlayerFlagToken(player);

  const flagHexKeys = Object.entries(hexes)
    .filter(([_hexKey, token]) => token === playerFlagToken)
    .map(([hexKey]) => hexKey);

  if (flagHexKeys.length === 0) {
    return null;
  }

  return getRandomElement(flagHexKeys);
};
